module.exports = __webpack_public_path__ + "img/sand-rock-medium-10.a5761ecb.png";